import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createSelector } from '@reduxjs/toolkit';
import { ShiftPlanState, SetShiftPlanDataPayload, SetStationCodePayload, SetPlanIdPayload } from '../types';

// Initial state
export const initialState: ShiftPlanState = {
  selectedDate: null,
  selectedShift: null,
  selectedPlan: null,
  stationCode: null,
  planId: null,
  isShiftPlanActive: false,
};

// Create the shift plan slice
const shiftPlanSlice = createSlice({
  name: 'shiftPlan',
  initialState,
  reducers: {
    setShiftPlanData: (state, action: PayloadAction<SetShiftPlanDataPayload>) => {
      state.selectedDate = action.payload.date;
      state.selectedShift = action.payload.shift;
      state.selectedPlan = action.payload.plan;
      state.isShiftPlanActive = true;
    },
    setStationCode: (state, action: PayloadAction<SetStationCodePayload>) => {
      state.stationCode = action.payload.stationCode;
    },
    setPlanId: (state, action: PayloadAction<SetPlanIdPayload>) => {
      state.planId = action.payload.planId;
    },
    clearShiftPlanData: (state) => {
      state.selectedDate = null;
      state.selectedShift = null;
      state.planId = null;
      state.isShiftPlanActive = false;
      state.selectedPlan = null;
    },
  },
});

// Export actions
export const { setShiftPlanData, setStationCode, setPlanId, clearShiftPlanData } = shiftPlanSlice.actions;

// Export reducer
export default shiftPlanSlice.reducer;

// Selectors
export const selectShiftPlanData = createSelector(
  [(state: { shiftPlan: ShiftPlanState }) => state.shiftPlan],
  (shiftPlan) => ({
    selectedDate: shiftPlan.selectedDate,
    selectedShift: shiftPlan.selectedShift,
    selectedPlan: shiftPlan.selectedPlan,
    stationCode: shiftPlan.stationCode,
    planId: shiftPlan.planId,
    isShiftPlanActive: shiftPlan.isShiftPlanActive,
  })
);

export const selectSelectedDate = (state: { shiftPlan: ShiftPlanState }) => state.shiftPlan.selectedDate;
export const selectSelectedShift = (state: { shiftPlan: ShiftPlanState }) => state.shiftPlan.selectedShift;
export const selectSelectedPlan = (state: { shiftPlan: ShiftPlanState }) => state.shiftPlan.selectedPlan;
export const selectStationCode = (state: { shiftPlan: ShiftPlanState }) => state.shiftPlan.stationCode;
export const selectPlanId = (state: { shiftPlan: ShiftPlanState }) => state.shiftPlan.planId;
export const selectIsShiftPlanActive = (state: { shiftPlan: ShiftPlanState }) => state.shiftPlan.isShiftPlanActive;
